import { CaseDisplayGroup } from "generated/graphql";
import { PopoverCell } from "../scripts/ScriptRoute";

export default function DisplayGroupsCell({
  propertyKey,
  displayGroups,
}: {
  propertyKey: string;
  displayGroups: CaseDisplayGroup[];
}) {
  const groupsContainingPropertyKey = displayGroups.filter((dg) =>
    dg.items.find((i) => i.caseCalcKey === propertyKey || i.casePropertyKey === propertyKey)
  );

  return (
    <PopoverCell
      output={groupsContainingPropertyKey.length > 0 ? groupsContainingPropertyKey.map((g) => g.name).join("\n") : ""}
    />
  );
}
